import { Installments } from '../components/Cart/OrderSummary/types';
import { Dispatch, SetStateAction } from 'react';

export const onContinueClick = (
  setSelectedPurchaseType: Dispatch<SetStateAction<Installments>>,
  onContinue?: () => void,
) => {
  onContinue && onContinue();
  setSelectedPurchaseType(Installments.P);
};
